import React, { useEffect, useState } from 'react';
import PageLayout from '../../components/common/page-layout';
import Grid from '@mui/material/Grid';
import { useGetAllUsers } from '../../api/requests/user';
import UsersTable from '../../components/tables/users-table';
import Button from '@mui/material/Button';
import ActionCard from '../../components/common/action-card';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import AssessmentIcon from '@mui/icons-material/Assessment';

export default function Users() {
  const [users, setUsers] = useState([]);

  const getAllUsers = useGetAllUsers();

  async function handleUsers() {
    const allUsers = await getAllUsers();
    setUsers(allUsers);
  }

  useEffect(() => {
    handleUsers();
  }, []);

  return (
    <PageLayout pageTitle="مدیریت کاربران">
      <Grid container spacing={3} sx={{ mb: 10 }}>
        <Grid item xs={12} sm={3}>
          <ActionCard name="مدیریت نقش‌ها" icon={<EnhancedEncryptionIcon />} path="/roles" />
        </Grid>
        <Grid item xs={12} sm={3}>
          <ActionCard name="لاگ کاربران" icon={<AssessmentIcon />} path="/logs" />
        </Grid>
        <Grid item xs={12} sm={3}>
          <ActionCard name="آپلودها" icon={<AssessmentIcon />} path="/uploads" />
        </Grid>
      </Grid>
      <Grid container justifyContent="center" spacing={3}>
        <Grid item xs={10} sm={8}>
          <Button variant="contained" color="primary" href="/users/create-user">
            افزودن کاربر
          </Button>
        </Grid>
        <Grid item xs={10} sm={8}>
          <UsersTable users={users} />
        </Grid>
      </Grid>
    </PageLayout>
  );
}
